import React from 'react';
import PropTypes from 'prop-types';

class ContactFilter extends React.Component {
    static propTypes = {
        contactFilter: PropTypes.string,
        onContactFilterChange: PropTypes.func.isRequired,
    };

    render() {
        const {contactFilter, onContactFilterChange} = this.props;

        return (
            <div className="chat__filter">
                <a tabIndex={4} className={'clickable' + (contactFilter === null ? ' active' : '')} onClick={() => onContactFilterChange(null)}>Vše</a>
                <a tabIndex={5} className={'clickable' + (contactFilter === 'text' ? ' active' : '')} onClick={() => onContactFilterChange('text')}>SMS</a>
                {/*<a tabIndex={6} className={'clickable' + (contactFilter === 'image' ? ' active' : '')} onClick={() => onContactFilterChange('image')}>Obrázky</a>*/}
                <a tabIndex={7} className={'clickable' + (contactFilter === 'voice' ? ' active' : '')} onClick={() => onContactFilterChange('voice')}>Hovory</a>
            </div>
        )
    }
}

export default ContactFilter;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Conversation/ContactFilter.jsx